import { render } from "./FormBills.vue?vue&type=template&id=72309b48&scoped=true"
import script from "./FormBills.vue?vue&type=script&lang=js"
export * from "./FormBills.vue?vue&type=script&lang=js"

import "./FormBills.vue?vue&type=style&index=0&id=72309b48&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72309b48"]])

export default __exports__